/* eslint-disable react-hooks/exhaustive-deps */
import { Form, InputNumber, notification, Popconfirm, Row, Select } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce/lib';

import TextButton from '../../../../../components/TextButton';
import { SubTitle } from '../../../../../components/Typography';
import DemandaEmbarque from '../../../../../domains/DemandaEmbarque';
import PrazoCarregamento from '../../../../../domains/PrazoCarregamento';
import TipoPagamentoEnum from '../../../../../Enum/TipoPagamentoEnum';
import ValidateCadenciaError from '../../../../../handlers/ValidateCadenciaError';
import ValidateVolumeError from '../../../../../handlers/ValidateVolumeError';
import { removeItemArrayObject } from '../../../../../helpers/array';
import { getDadosCalculoFreteSeparado } from '../../../../../helpers/calculaValoresLote';
import { pegarDataUtc } from '../../../../../helpers/data';
import {
  formatarMilhar,
  removeThousandSeparatorMask,
} from '../../../../../helpers/formatador';
import geradorIdUnico from '../../../../../helpers/geradores';
import { gTagEntrada, gTagSaida } from '../../../../../helpers/googleAnalytics';
import { getTransportadoras } from '../../../../../helpers/transportadoras';
import {
  validateCadencia,
  validateVolumeMovimentado,
} from '../../../../../helpers/validators';
import { useBoolean } from '../../../../../hooks/useBoolean';
import { useAuth } from '../../../../../security/authContext';
import apiShipper from '../../../../../services/apiShipper';
import {
  AgendamentoCollapse,
  ItemAgendamento,
  Panel,
} from '../../../@components/AgendamentoCollapse';
import { useAgendamentoAlteracaoContext } from '../../../Contextos/AgendamentoAlteracaoContexto';
import TipoAlteracaoEnum from '../../../Enum/TipoAlteracaoEnum';
import TipoDirecionamentoEnum from '../../../Enum/TipoDirecionamentoEnum';
import { Card, ColCard, Title } from '../../styles';
import { GlobalStyle } from '../DadosGerais/styles';
import CarregamentoModal from './CarregamentoModal';
import { getColumns } from './columns';
import { recalculaFretes } from './Modal/helpers/calculos';
import ModalCriarLote from './Modal/modalCriarLote';
import {
  CancelarAgendamentoButton,
  CardVolume,
  Col,
  DatePicker,
  IncluirNovoLoteButton,
  SalvarAgendamentoButton,
  SelectContainer,
  Spin,
  Switch,
  Table,
  TextCardVolume,
  TitleCardVolume,
} from './styles';

export default function StepDemanda({
  demanda,
  setDemanda,
  lotes,
  setLotes,
  dadosPagador,
  clienteEnderecoRemetente,
  clienteEnderecoDestinatario,
  clienteExpedidor,
  clienteRecebedor,
  setAlertMessageErrors,
  editingDemanda,
  idDemanda,
  hasMotorista,
}) {
  const [showModalCriarLote, setshowModalCriarLote] = useState(false);
  const [showModalCarregamento, setShowModalCarregamento] = useState(false);
  const [freqCarregamento, setFreqCarregamento] = useState(
    DemandaEmbarque.getEmbarqueOption(demanda.demandaHorariosEmbarque)
  );
  const [prazoCarregamento, setPrazoCarregamento] = useState(
    PrazoCarregamento.getPrazoCarregamentoOption(demanda.periodoCarregamento)
  );
  const [endereco, setEndereco] = useState({});
  const [freteInserido, setFreteInserido] = useState('motorista');
  const [volumeTotal, setVolumeTotal] = useState(0);
  const [cadenciaDiariaTotal, setCadenciaDiariaTotal] = useState(0);
  const [loteEditing, setLoteEditing] = useState({});
  const [loadingLotes, setLoadingLotes] = useState(false);
  const [loadingLivreConcorrencia, setLoadingLivreConcorrencia] = useState(
    false
  );
  const [indexLote, setIndexLote] = useState(0);
  const [tarifaTmovClienteLista, setTarifaTmovClienteLista] = useState();
  const [valorPedagio, setValorPedagio] = useState(0);
  const [icms, setIcms] = useState(0);
  const [eventId, setEventId] = useState('');
  const [switchLivreConcorrencia, setSwitchLivreConcorrencia] = useState(false);
  const [errorCadenciaTotal, setErrorCadenciaTotal] = useState(null);
  const [errorVolumeTotal, setErrorVolumeTotal] = useState(null);
  const [dataAlteracaoAgendamento, setDataAlteracaoAgendamento] = useState(
    null
  );
  const [dadosDemandaAgendamento, setDadosDemandaAgendamento] = useState();
  const [previousVolumeTotal, setPreviousVolumeTotal] = useState(null);
  const [
    previousCadenciaDiariaTotal,
    setPreviousCadenciaDiariaTotal,
  ] = useState(null);
  const [tipoLote, setTipoLote] = useState(null);
  const [apiTransportadoras, setApiTransportadoras] = useState([]);

  const {
    agendamentosAlteracao,
    setAgendamentosAlteracao,
    removeAgendamentoAlteracao,
  } = useAgendamentoAlteracaoContext();
  const [form] = Form.useForm();
  const { user } = useAuth();
  const { value: loadingCancelar, toggle: toggleLoadingCancelar } = useBoolean(
    false
  );

  const empresasParceiras = useMemo(() => {
    const empresasRestante = apiTransportadoras.filter(
      empresa => !lotes.find(lote => lote.idTransportadora === empresa.id)
    );

    if (loteEditing) {
      const empresaSelecionada = apiTransportadoras.find(
        empresa => empresa.id === loteEditing.idTransportadora
      );
      if (empresaSelecionada) empresasRestante.push(empresaSelecionada);
    }
    return empresasRestante;
  }, [lotes.length, apiTransportadoras, loteEditing]);

  /**
   * @description Método não estava sendo usando,
   * levantar a possibilidade de exclusão do mesmo.
   */
  /* const cadenciaMovimentadaTotal = useMemo(() => {
    if (demanda.lotes) {
      return demanda.lotes.reduce(
        (acumulador, lote) => (lote?.cadenciaMovimentada + acumulador), 0
      );
    }
    return 0;
  }, [demanda.lotes]); */

  const volumeMovimentadoTotal = useMemo(() => {
    if (demanda.lotes) {
      return demanda.lotes.reduce(
        (acumulador, lote) => lote?.volumeMovimentado + acumulador,
        0
      );
    }
    return 0;
  }, [demanda.lotes]);

  const atualizaFretes = lote =>
    recalculaFretes({
      ...lote,
      valorPedagio,
      tarifaTmovClienteLista,
      isTarifaPercentual: tarifaTmovClienteLista.tipoTarifa === 'PERCENTUAL',
    });

  const atualizaVolumeCadencia = currentlote => {
    const loteDemanda = demanda.lotes
      ? demanda.lotes.find(lote => lote.idLote === currentlote.idLote)
      : undefined;

    let novoVolumeECadencia;

    if (demanda.livreConcorrencia) {
      novoVolumeECadencia = {
        cadencia: cadenciaDiariaTotal,
        volume: volumeTotal,
      };
    } else if (loteDemanda) {
      novoVolumeECadencia = {
        cadencia: currentlote.cadenciaAux
          ? currentlote.cadenciaAux
          : currentlote.cadencia,
        volume: currentlote.volumeAux
          ? currentlote.volumeAux
          : currentlote.volume,
      };
    } else {
      novoVolumeECadencia = {
        cadencia: currentlote.cadenciaAux,
        volume: currentlote.volumeAux,
      };
    }

    return novoVolumeECadencia;
  };

  const lotesTableAtualizados = useMemo(() => {
    if (!tarifaTmovClienteLista) return;

    return lotes.map(lote => {
      if (lote.tipoDirecionamento === TipoDirecionamentoEnum.MARKETPLACE) {
        return {
          ...lote,
          ...atualizaFretes(lote),
          ...atualizaVolumeCadencia(lote),
        };
      }
      return { ...lote, ...atualizaVolumeCadencia(lote) };
    });
  }, [
    tarifaTmovClienteLista,
    valorPedagio,
    volumeTotal,
    cadenciaDiariaTotal,
    switchLivreConcorrencia,
  ]);

  const getDadosTransportadora = async () => {
    const { data } = await apiShipper.get('/empresas-parceiras');
    const transportadora = await getTransportadoras(
      user,
      data.empresas_tmov_id
    );
    if (transportadora) setApiTransportadoras(transportadora);
  };

  const saveNovoLote = novoLote => {
    lotes.push(novoLote);
    setLotes(lotes);
    gTagSaida(
      'Click - Salvar Novo Lote',
      'Demanda',
      'Novo lote inserido',
      eventId
    );
  };

  const onSaveLote = (novoLote, idLote) => {
    if (loteEditing == null) {
      return saveNovoLote(novoLote);
    }

    lotes[indexLote] = {
      ...novoLote,
      idLote,
    };

    setLotes(lotes);
    gTagSaida(
      'Click - Salvar Lote Editado',
      'Demanda',
      'Lote Editado',
      eventId
    );
  };

  const handleModalCriarLote = () => {
    const customEventId = geradorIdUnico();
    gTagEntrada(
      'Click - Criar Novo Lote',
      'Demanda',
      'Criação de novo lote',
      customEventId
    );
    setEventId(customEventId);

    form.resetFields();
    setLoteEditing(null);
    setshowModalCriarLote(true);
  };

  const handleCloseModal = () => {
    form.resetFields();
    setshowModalCriarLote(false);
  };

  const handleDeletarLote = (loteRemovido, index) => {
    try {
      setLotes(l => [...l.slice(0, index), ...l.slice(index + 1)]);

      notification.success({
        message: 'Remover Lote',
        description: 'Este lote foi removido com sucesso.',
      });
    } catch (error) {
      notification.error({
        message: 'Ops, não foi possível remover o lote',
        description:
          'Por favor, entre em contato com nosso suporte caso o problema persistir.',
      });
    }
  };

  const handleEditarLote = (lote, index) => {
    setLoteEditing(lote);
    setIndexLote(index);
    setshowModalCriarLote(true);

    const customEventId = geradorIdUnico();
    gTagEntrada(
      'Click - Editar Lote',
      'Demanda',
      'Editando lote.',
      customEventId
    );
    setEventId(customEventId);
  };

  const validarCadenciaComPesoTotal = async (cadencia, dataAlteracao) => {
    try {
      if (!dataAlteracao || dadosDemandaAgendamento) {
        return;
      }

      setLoadingLivreConcorrencia(true);

      const { data } = await apiShipper.get('/motoristas/peso', {
        params: {
          idLotes: lotes.map(lote => lote.idLote),
          data: dataAlteracao,
        },
      });
      const pesoTotal = data;

      if (dataAlteracao && pesoTotal > cadencia) {
        setAlertMessageErrors(state => [
          ...removeItemArrayObject(state, 'key', 'validate-cadencia'),
          {
            key: 'validate-cadencia',
            message:
              'A cadência agendada é menor que o volume para embarque nesta data',
            fixed: true,
          },
        ]);
        return;
      }

      setErrorCadenciaTotal(null);
      setAlertMessageErrors(state => [
        ...removeItemArrayObject(state, 'key', 'validate-cadencia'),
      ]);
    } catch (err) {
      if (err instanceof ValidateCadenciaError) {
        throw err;
      }
      notification.error({
        message:
          'Ocorreu um erro ao validar a cadência diária com o peso total dos motoristas',
      });
    } finally {
      setLoadingLivreConcorrencia(false);
    }
  };

  const validateLivreConcorrenciaDebounced = useDebouncedCallback(
    validarCadenciaComPesoTotal,
    600
  );

  useEffect(() => {
    if (dadosDemandaAgendamento) return;
    validateLivreConcorrenciaDebounced(
      cadenciaDiariaTotal,
      dataAlteracaoAgendamento
    );
  }, [cadenciaDiariaTotal, dataAlteracaoAgendamento]);

  const columnsTable = getColumns(handleEditarLote, handleDeletarLote);

  const cleanErros = () => {
    setErrorCadenciaTotal(null);
    setErrorVolumeTotal(null);
    setAlertMessageErrors(state => [
      ...removeItemArrayObject(state, 'key', 'validate-cadencia'),
    ]);
    setAlertMessageErrors(state => [
      ...removeItemArrayObject(state, 'key', 'validate-volume'),
    ]);
  };

  const handleValidate = async (cadenciaTotalValid, volumeTotalValid) => {
    try {
      cleanErros();

      if (!demanda.livreConcorrencia) return;

      await validateVolumeMovimentado(volumeTotalValid, volumeMovimentadoTotal);
      await validateCadencia(cadenciaTotalValid, volumeTotalValid);

      /** @decription validação pendente para o futuro */
      // await validateCadenciaMovimentado(cadenciaTotalValid, cadenciaMovimentadaTotal);
    } catch (error) {
      let keyError = 'generic';
      if (error instanceof ValidateVolumeError) {
        keyError = 'validate-volume';
        setErrorVolumeTotal(error.message);
      }
      if (error instanceof ValidateCadenciaError) {
        keyError = 'validate-cadencia';
        setErrorCadenciaTotal(error.message);
      }
      setAlertMessageErrors(state => [
        ...removeItemArrayObject(state, 'key', keyError),
        {
          key: keyError,
          message: error.message,
          fixed: true,
        },
      ]);
    }
  };

  const handleSetCadenciaDiariaTotal = async cadencia => {
    const cadenciaFormated = cadencia.toString().replace(/[^\d.,]/g, '');

    if (switchLivreConcorrencia) {
      handleValidate(cadenciaFormated, volumeTotal);
    }

    setCadenciaDiariaTotal(cadenciaFormated);

    if (!previousCadenciaDiariaTotal) {
      setPreviousCadenciaDiariaTotal(demanda.cadenciaDiariaTotal);
    }

    demanda.cadenciaDiariaTotal = cadenciaFormated;
    setDemanda(demanda);
  };

  const handleSetVolumeTotal = async volume => {
    const volumeFormated = volume.toString().replace(/[^\d.,]/g, '');

    if (switchLivreConcorrencia) {
      handleValidate(cadenciaDiariaTotal, volumeFormated);
    }

    if (!previousVolumeTotal) {
      setPreviousVolumeTotal(demanda.volumeTotal);
    }

    setVolumeTotal(volumeFormated);

    demanda.volumeTotal = volumeFormated;
    setDemanda(demanda);
  };

  const getValorTotal = async () => {
    let volume = 0;
    let cadencia = 0;

    if (lotes && lotes.length > 0) {
      lotes.forEach(lote => {
        volume += removeThousandSeparatorMask(lote.volume);
        cadencia += removeThousandSeparatorMask(lote.cadencia);
      });
    }

    handleSetVolumeTotal(volume);
    handleSetCadenciaDiariaTotal(cadencia);
  };

  const isDisabledCriarLote = () => {
    const volumeTotalValidated =
      !demanda.volumeTotal || demanda.volumeTotal === '0';
    const cadenciaDiariaTotalValidated =
      !demanda.cadenciaDiariaTotal || demanda.cadenciaDiariaTotal === '0';

    return (
      switchLivreConcorrencia &&
      (volumeTotalValidated ||
        cadenciaDiariaTotalValidated ||
        errorCadenciaTotal ||
        errorVolumeTotal)
    );
  };

  const isDisabledSalvarAgendamento = () =>
    (volumeTotal.toString() === previousVolumeTotal?.toString() &&
      cadenciaDiariaTotal.toString() ===
        previousCadenciaDiariaTotal?.toString()) ||
    !demanda.volumeTotal ||
    !demanda.cadenciaDiariaTotal ||
    errorVolumeTotal ||
    !dataAlteracaoAgendamento;

  const onChangeSwitch = checked => {
    cleanErros();
    setSwitchLivreConcorrencia(checked);

    demanda.livreConcorrencia = checked;
    setDemanda(demanda);

    if (!checked) {
      getValorTotal();
    }
  };

  const handleDataAlteracaoAgendamento = async dataAlteracao => {
    const dataFormated = dataAlteracao ? pegarDataUtc(dataAlteracao) : null;
    setDataAlteracaoAgendamento(dataFormated);
  };

  const getAgendamentoDemanda = async () => {
    try {
      const { data } = await apiShipper.get('alteracao-demanda', {
        params: {
          id_demanda: idDemanda,
        },
      });

      const agendamentoAlteracaoLivreConcorrencia = data.find(
        alteracao =>
          alteracao.tipo_alteracao === TipoAlteracaoEnum.LIVRE_CONCORRENCIA
      );

      setAgendamentosAlteracao(data);

      if (
        agendamentoAlteracaoLivreConcorrencia &&
        (agendamentoAlteracaoLivreConcorrencia?.volume ||
          agendamentoAlteracaoLivreConcorrencia?.cadencia)
      ) {
        setDadosDemandaAgendamento(agendamentoAlteracaoLivreConcorrencia);
      }
    } catch (error) {
      notification.error({
        message: 'Erro ao recuperar os dados de agendamento',
        description:
          'Não foi possível recuperar os dados de agendamento da demanda',
      });
    }
  };

  const handleSalvarAgendamentoLivreConcorrencia = async () => {
    try {
      if (loadingLivreConcorrencia) return;

      const emails = [];
      demanda.lotes.forEach(l => {
        l.filiaisEmail.forEach(email => {
          if (email && !emails.includes(email)) {
            emails.push(email);
          }
        });
      });

      if (volumeTotal && cadenciaDiariaTotal && dataAlteracaoAgendamento) {
        const origemFormatado = `${demanda?.enderecoOrigem[0].cidade} (${demanda?.enderecoOrigem[0].estado})`.toUpperCase();
        const destinoFormatado = `${demanda?.enderecoDestino[0].cidade} (${demanda?.enderecoDestino[0].estado})`.toUpperCase();
        const razaoSocialFormatada = demanda?.razaoSocialClientePagador.toUpperCase();

        await apiShipper.post('/alteracao-demanda', {
          id_demanda: idDemanda,
          data_alteracao: dataAlteracaoAgendamento,
          volume:
            volumeTotal.toString() !== previousVolumeTotal.toString()
              ? volumeTotal
              : null,
          cadencia:
            cadenciaDiariaTotal.toString() !==
            previousCadenciaDiariaTotal.toString()
              ? cadenciaDiariaTotal
              : null,
          email_filiais: emails,
          cliente_razao_social: razaoSocialFormatada,
          origem: origemFormatado,
          destino: destinoFormatado,
          tipo_alteracao: TipoAlteracaoEnum.LIVRE_CONCORRENCIA,
        });

        handleSetVolumeTotal(previousVolumeTotal);
        handleSetCadenciaDiariaTotal(previousCadenciaDiariaTotal);

        await getAgendamentoDemanda();

        notification.success({
          message: 'Agendamento de alteração de demanda',
          description: 'Os dados foram salvos e agendados!',
        });
      }
    } catch (error) {
      notification.error({
        message: 'Erro inesperado ao salvar agendamento',
        description: 'Ocorreu um erro inesperado ao salvar o agendamento',
      });
    }
  };

  const handleCancelarAgendamentoLivreConcorrencia = async () => {
    try {
      toggleLoadingCancelar();
      await apiShipper.put('alteracao-demanda', {
        status: 'CANCELADO',
        id_demanda: idDemanda,
        tipo_alteracao: TipoAlteracaoEnum.LIVRE_CONCORRENCIA,
      });
      removeAgendamentoAlteracao(dadosDemandaAgendamento);
      setDadosDemandaAgendamento();
      setDataAlteracaoAgendamento(null);
      notification.success({
        message: 'Agendamento de alteração cancelado!',
        description:
          'O agendaamento de alteração previsto foi cancelado com sucesso!',
      });
    } catch (error) {
      notification.error({
        message: 'Erro inesperado ao cancelar agendamento',
        description: 'Ocorreu um erro inesperado ao cancelar o agendamento',
      });
    } finally {
      toggleLoadingCancelar();
    }
  };

  useEffect(() => {
    if (lotesTableAtualizados) setLotes(lotesTableAtualizados);
  }, [lotesTableAtualizados]);

  const getDadosClienteById = async () => {
    const { data } = await apiShipper.get(
      `/clientes/${demanda.idClienteShipper}`
    );
    setTipoLote(
      data?.tipo_lote === 'MARKETPLACE' ? 'MARKETPLACE' : 'TRANSPORTADORA'
    );
  };

  useEffect(() => {
    const onInit = async () => {
      setshowModalCriarLote(false);
      setLoadingLotes(true);

      try {
        const dadosEndereco = {
          idEstadoOrigem:
            clienteExpedidor[0].idEstado ||
            clienteEnderecoRemetente[0].idEstado,
          idEstadoDestino:
            clienteRecebedor[0].idEstado ||
            clienteEnderecoDestinatario[0].idEstado,
          idCidadeOrigem:
            clienteExpedidor[0].idCidade ||
            clienteEnderecoRemetente[0].idCidade,
          idCidadeDestino:
            clienteRecebedor[0].idCidade ||
            clienteEnderecoDestinatario[0].idCidade,
          ibgeOrigem:
            clienteExpedidor[0].ibgeCidade ||
            clienteEnderecoRemetente[0].ibgeCidade,
          ibgeDestino:
            clienteRecebedor[0].ibgeCidade ||
            clienteEnderecoDestinatario[0].ibgeCidade,
        };
        setEndereco(dadosEndereco);

        if (!dadosEndereco.idEstadoOrigem || !dadosPagador.id_cliente_raiz) {
          return;
        }

        const {
          pedagioCalculado,
          tarifaTmovCliente,
          valorICMS,
        } = await getDadosCalculoFreteSeparado(
          dadosEndereco,
          dadosPagador.id_cliente_raiz
        );

        setValorPedagio(pedagioCalculado);
        setTarifaTmovClienteLista(tarifaTmovCliente);
        setIcms(valorICMS / 100);
        getDadosTransportadora();
        await getDadosClienteById();
      } catch (error) {
        notification.error({
          message:
            'Ops, não foi possível recuperar valores para calcular frete',
          description:
            'Por favor, entre em contato com nosso suporte caso o problema persistir.',
        });
      } finally {
        setLoadingLotes(false);
      }
    };

    onInit();
  }, [
    clienteEnderecoDestinatario,
    clienteEnderecoRemetente,
    clienteExpedidor,
    clienteRecebedor,
    dadosPagador,
  ]);

  useEffect(() => {
    const loadDemandaAgendamento = async () => {
      if (!editingDemanda || !demanda.livreConcorrencia) return;
      await getAgendamentoDemanda();
    };
    loadDemandaAgendamento();
  }, [demanda]);

  useEffect(() => {
    if (demanda.livreConcorrencia) {
      setSwitchLivreConcorrencia(demanda.livreConcorrencia);
      handleSetCadenciaDiariaTotal(demanda.cadenciaDiariaTotal);
      handleSetVolumeTotal(demanda.volumeTotal);
    } else {
      setSwitchLivreConcorrencia(false);
      demanda.livreConcorrencia = false;
      setDemanda(demanda);
      getValorTotal();
    }
  }, [
    lotes,
    showModalCriarLote,
    switchLivreConcorrencia,
    volumeTotal,
    cadenciaDiariaTotal,
  ]);

  useEffect(() => {
    demanda.demandaHorariosEmbarque = freqCarregamento.embarque;
    demanda.periodoCarregamento = prazoCarregamento.value;

    setDemanda(demanda);
  }, [freqCarregamento, prazoCarregamento]);

  const hasAnyAgendamento = Object.keys(agendamentosAlteracao).length > 0;

  const getTipoPagamento = () =>
    TipoPagamentoEnum.getValues().filter(
      item =>
        item.value === TipoPagamentoEnum.POR_TONELADA ||
        item.value === TipoPagamentoEnum.POR_FRETE_CHEIO
    );

  const handleTipoPagamento = value => {
    demanda.tipoPagamento = value;
    setDemanda(demanda);
  };

  useEffect(() => {
    if (!demanda.tipoPagamento) {
      handleTipoPagamento(TipoPagamentoEnum.POR_TONELADA);
    }
  }, []);

  const validaTipoPagamento = () =>
    editingDemanda
      ? demanda.tipoPagamento ?? TipoPagamentoEnum.POR_TONELADA
      : TipoPagamentoEnum.POR_TONELADA;

  return (
    <>
      <GlobalStyle />
      <Row style={{ height: '90%' }}>
        <CarregamentoModal
          visible={showModalCarregamento}
          setVisible={setShowModalCarregamento}
          freqCarregamento={freqCarregamento}
          setFreqCarregamento={setFreqCarregamento}
          prazoCarregamento={prazoCarregamento}
          setPrazoCarregamento={setPrazoCarregamento}
        />
        {tarifaTmovClienteLista && (
          <ModalCriarLote
            demanda={demanda}
            title={loteEditing ? 'Editar lote' : 'Criar Lote'}
            showModal={showModalCriarLote}
            handleCloseModal={handleCloseModal}
            onSaveLote={onSaveLote}
            setFreteInserido={setFreteInserido}
            freteInserido={freteInserido}
            dadosPagador={dadosPagador}
            formDemanda={form}
            endereco={endereco}
            destroyOnClose={true}
            lote={loteEditing}
            icms={icms}
            valorPedagio={valorPedagio}
            tarifaTmovClienteLista={tarifaTmovClienteLista}
            eventId={eventId}
            empresasParceiras={empresasParceiras}
            todosLotesInclusos={lotes}
            tipoLote={tipoLote}
          />
        )}

        <ColCard span={24} className="height-71">
          <Card className="height-71">
            <Title>Direcionamentos</Title>
            <Row
              style={{
                marginTop: 15,
                marginBottom: 15,
                alignItems: 'center',
                gap: 5,
                width: '100%',
              }}
            >
              <SelectContainer>
                <span style={{ width: '120%' }}>Tipo de pagamento:</span>
                <Select
                  style={{ width: '100%' }}
                  data-testid="tipo-pagamento"
                  aria-label="tipoPagamento"
                  defaultValue={validaTipoPagamento()}
                  disabled={hasMotorista}
                  showAction={['click']}
                  onChange={value => handleTipoPagamento(value)}
                >
                  {getTipoPagamento().map(item => (
                    <Select.Option key={item.value} value={item.value}>
                      {item.label}
                    </Select.Option>
                  ))}
                </Select>
              </SelectContainer>

              <Col style={{ marginLeft: '5px' }}>
                &nbsp;
                {freqCarregamento && `Carregamento: ${freqCarregamento.name} `}
                {prazoCarregamento &&
                  `(Incluir motoristas ${prazoCarregamento.name.toLowerCase()})`}
                <TextButton
                  type="button"
                  onClick={() => setShowModalCarregamento(true)}
                >
                  Alterar
                </TextButton>
              </Col>
            </Row>

            {hasAnyAgendamento && (
              <Row>
                <Col span={24}>
                  <AgendamentoCollapse expandIconPosition="right">
                    <Panel>
                      {agendamentosAlteracao.map(agendamento => (
                        <ItemAgendamento
                          key={agendamento.id}
                          agendamento={agendamento}
                        />
                      ))}
                    </Panel>
                  </AgendamentoCollapse>
                </Col>
              </Row>
            )}

            <Row>
              <Col span={24}>
                <Row justify="space-around" align="middle" gutter={[8, 16]}>
                  <Col>
                    <SubTitle>
                      Livre concorrência:&nbsp;
                      <Switch
                        checked={switchLivreConcorrencia}
                        size="small"
                        onChange={onChangeSwitch}
                        disabled={editingDemanda}
                      />
                    </SubTitle>
                  </Col>
                  {switchLivreConcorrencia && (
                    <>
                      <Col>
                        <SubTitle>Volume total (ton): </SubTitle>
                        <InputNumber
                          value={volumeTotal}
                          disabled={false}
                          onChange={value => handleSetVolumeTotal(value)}
                          aria-label="demandaVolumeTotal"
                          type="number"
                          pattern="[0-9]*"
                          precision={2}
                          parser={value => value.substring(0, 6)}
                        />
                      </Col>
                      <Col>
                        <SubTitle>Cadência total (ton): </SubTitle>
                        <InputNumber
                          value={cadenciaDiariaTotal}
                          disabled={loadingLivreConcorrencia}
                          onChange={value =>
                            handleSetCadenciaDiariaTotal(value)
                          }
                          aria-label="demandaCadenciaDiariaTotal"
                          type="number"
                          pattern="[0-9]*"
                          precision={2}
                          parser={value => value.substring(0, 6)}
                        />
                      </Col>
                    </>
                  )}

                  {editingDemanda && demanda.livreConcorrencia && (
                    <>
                      {!dadosDemandaAgendamento && (
                        <Col>
                          <SubTitle>Data de alteração: </SubTitle>
                          <DatePicker
                            className="total-width"
                            disabledDate={d => !d || d.isBefore(moment())}
                            onChange={value =>
                              handleDataAlteracaoAgendamento(value)
                            }
                            format="DD/MM/YYYY"
                            disabled={loadingLivreConcorrencia}
                          />
                        </Col>
                      )}

                      <Col>
                        {dadosDemandaAgendamento && (
                          <Popconfirm
                            title="Tem certeza que deseja cancelar este agendamento? Esta ação é irrevesível"
                            onConfirm={
                              handleCancelarAgendamentoLivreConcorrencia
                            }
                          >
                            <CancelarAgendamentoButton
                              type="primary"
                              data-testid="cancelar-agendamento"
                              loading={loadingCancelar}
                            >
                              Cancelar
                            </CancelarAgendamentoButton>
                          </Popconfirm>
                        )}
                      </Col>

                      <Col>
                        {loadingLivreConcorrencia &&
                          !dadosDemandaAgendamento && <Spin />}
                      </Col>

                      <Col>
                        {!dadosDemandaAgendamento && (
                          <SalvarAgendamentoButton
                            type="primary"
                            data-testid="salvar"
                            onClick={handleSalvarAgendamentoLivreConcorrencia}
                            disabled={
                              isDisabledSalvarAgendamento() ||
                              loadingLivreConcorrencia
                            }
                          >
                            Salvar
                          </SalvarAgendamentoButton>
                        )}
                      </Col>
                    </>
                  )}

                  <Col marginleft="auto">
                    <IncluirNovoLoteButton
                      loading={loadingLotes}
                      type="primary"
                      onClick={handleModalCriarLote}
                      disabled={isDisabledCriarLote()}
                    >
                      Criar Lote
                    </IncluirNovoLoteButton>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Table
                  loading={{
                    spinning: loadingLotes,
                    indicator: (
                      <Spin
                        style={{
                          width: '0%',
                        }}
                      />
                    ),
                  }}
                  dataSource={
                    lotes.length &&
                    lotes.map(lote => ({
                      ...lote,
                      key: lote.idLote,
                    }))
                  }
                  columns={columnsTable}
                  pagination={false}
                />
              </Col>
            </Row>

            {!demanda.livreConcorrencia && (
              <Row style={{ marginTop: 30 }}>
                <Col span={11}>
                  <CardVolume bordered={true}>
                    <TitleCardVolume>Volume total (t)</TitleCardVolume>
                    <Row justify="center">
                      <Col>
                        <TextCardVolume>
                          {formatarMilhar(volumeTotal)}
                        </TextCardVolume>
                      </Col>
                    </Row>
                  </CardVolume>
                </Col>
                <Col span={12} offset={1}>
                  <CardVolume bordered={true}>
                    <TitleCardVolume>Cadência diária total (t)</TitleCardVolume>
                    <Row justify="center">
                      <Col>
                        <TextCardVolume>
                          {formatarMilhar(cadenciaDiariaTotal)}
                        </TextCardVolume>
                      </Col>
                    </Row>
                  </CardVolume>
                </Col>
              </Row>
            )}
          </Card>
        </ColCard>
      </Row>
    </>
  );
}

StepDemanda.propTypes = {
  demanda: PropTypes.objectOf(PropTypes.any).isRequired,
  setDemanda: PropTypes.func.isRequired,
  lotes: PropTypes.arrayOf(PropTypes.any).isRequired,
  setLotes: PropTypes.func.isRequired,
  dadosPagador: PropTypes.objectOf(PropTypes.any).isRequired,
  clienteEnderecoRemetente: PropTypes.arrayOf(PropTypes.any).isRequired,
  clienteEnderecoDestinatario: PropTypes.arrayOf(PropTypes.any).isRequired,
  clienteExpedidor: PropTypes.arrayOf(PropTypes.any).isRequired,
  clienteRecebedor: PropTypes.arrayOf(PropTypes.any).isRequired,
  setAlertMessageErrors: PropTypes.func.isRequired,
  editingDemanda: PropTypes.bool.isRequired,
  idDemanda: PropTypes.string.isRequired,
  hasMotorista: PropTypes.bool.isRequired,
};
